import { useTranslation } from 'react-i18next'

import ImgInCircle from 'components/UI/ImgInCircle/ImgInCircle'
import { AllIcons } from 'helpers/allIcons'
import { LoginForm } from 'pages/auth/view/LoginForm'

interface GuestSubscribeLoginProps {
  displayName: string
  username: string
  avatar?: string | null
  cover?: string | null
  onClose?: () => void
  hideProfileHeader?: boolean
}

export const GuestSubscribeLogin = ({
  displayName,
  username,
  avatar,
  cover,
  onClose,
  hideProfileHeader = false
}: GuestSubscribeLoginProps) => {
  const { t } = useTranslation()

  return (
    <div
      className={`subscribe-profile-modal-wrapper subscribe-profile-modal-wrapper-unauth ${
        hideProfileHeader ? 'guest-no-cover' : ''
      }`}
    >
      <div className='subscribe-profile-modal-container'>

        {!hideProfileHeader && (
          <div className='guest-subscribe-cover'>
            {cover && (
              <img
                className='guest-subscribe-cover-image'
                src={cover}
                alt=''
              />
            )}

            <div className='guest-subscribe-cover-gradient' />

            <div className='guest-subscribe-profile'>
              <img
                className='guest-subscribe-avatar'
                src={avatar || AllIcons.user_placeholder}
                alt={t('profileAvatar')}
              />

              <div className='guest-subscribe-profile-text'>
                <div className='guest-subscribe-name'>
                  {displayName}
                </div>

                <div className='guest-subscribe-username'>
                  @{username}
                </div>
              </div>
            </div>
          </div>
        )}

        <div className='guest-subscribe-content'>

          {hideProfileHeader && (
            <ImgInCircle
              type='login'
              customClass='guest-login-logo'
            >
              <img
                src='/logo.png'
                alt={t('logo')}
                style={{
                  width: '50px',
                  height: '50px',
                  objectFit: 'contain'
                }}
              />
            </ImgInCircle>
          )}

          <div className='subscribe-profile-modal-login-container'>
            <LoginForm
              fromUser
              showNormalLoginTitle={hideProfileHeader}
              onSuccessInModal={() => {
                onClose?.()
              }}
            />
          </div>

        </div>
      </div>
    </div>
  )
}

export default GuestSubscribeLogin